import React, { useState } from 'react'
import getText from '../strings'
import { colors, Message } from '../../styles'
import { Svg, fetchr } from '../../application'
import styled from 'react-emotion'
import { settings } from '../../resources'

const Wrapper = styled('div')`
  .btn {
    margin: 10px 0 0 0;
    width: unset !important;
  }
`

const WithIcon = styled('div')`
  display: flex;
  align-items: center;
  svg.pictogram {
    margin-right: 5px;
  }
`

export default ({ caseId }) => {
  const [error, setError] = useState(false)
  const [loading, setLoading] = useState(false)

  const getFile = () => {
    setError(false)
    setLoading(true)
    fetchr(`${settings.apiAuthorizedRestUrl}/privacy/cases/${caseId}`, false)
      .get()
      .then(response => response.blob())
      .then(blob => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob)
          window.navigator.msSaveOrOpenBlob(blob, 'gdpr.pdf')
        else {
          const a = document.createElement('a')
          const url = window.URL.createObjectURL(blob)
          a.style = "display: none"
          a.href = url
          a.download = 'gdpr.pdf'
          document.body.appendChild(a)
          a.click()
          setTimeout(function () {
            document.body.removeChild(a)
            window.URL.revokeObjectURL(url)
          }, 100);
        }
      })
      .then(() => {
        setLoading(false)
      })
      .catch(() => {
        setError(true)
        setLoading(false)
      })
  }

  return (
    <Wrapper>
      <div>
        <h4>{getText('download', 'downloadExtract')}</h4>
        <WithIcon>
          <Svg icon="badge-check" style={{ color: colors.tui_green }} />
          {getText('download', 'extractReady')}
        </WithIcon>
      </div>
      <button
        onClick={() => getFile(caseId)}
        disabled={loading}
        type="button"
        className={`btn btn-sm btn-function ${loading ? 'btn-loading' : ''}`}>
        {getText('download', 'downloadNow')}
      </button>
      {error && <Message error={true}>{getText('errors', 'general')}</Message>}
    </Wrapper>
  )
}